export const USER_DESELECT_CLASS = 'horizon/views/USER_DESELECT_CLASS'
export const USER_SELECT_CLASS = 'horizon/views/USER_SELECT_CLASS'
export const USER_DELETE_VIEW = 'horizon/views/USER_DELETE_VIEW'
export const USER_SELECT_FACTOID = 'horizon/views/USER_SELECT_FACTOID'
export const USER_DESELECT_FACTOID = 'horizon/views/USER_DESELECT_FACTOID'
export const USER_ADD_BUSINESS_LINE = 'horizon/views/USER_ADD_BUSINESS_LINE'
export const USER_REMOVE_BUSINESS_LINE =
  'horizon/views/USER_REMOVE_BUSINESS_LINE'
export const FACTOID_SELECTIONS_SORT_SUCCESS =
  'horizon/views/FACTOID_SELECTIONS_SORT_SUCCESS'
export const GENERATE_BUSINESS_LINE_SELECTIONS =
  'horizon/views/GENERATE_BUSINESS_LINE_SELECTIONS'
export const SORT_BUSINESS_LINE_SELECTIONS =
  'horizon/views/SORT_BUSINESS_LINE_SELECTIONS'
export const USER_ADD_BUSINESS_LINE_RECOMMENDATION =
  'horizon/views/USER_ADD_BUSINESS_LINE_RECOMMENDATION'
export const RESET_SELECTIONS = 'horizon/views/RESET_SELECTIONS'


// WEBPACK FOOTER //
// ./src/views/duck/types.ts